import formatSqlAlias from './formatSqlAlias';

function replaceSqlAliases(sqlQuery: string, aliasMap: Record<string, string>): string {
  const selectClauseMatch = sqlQuery.match(/SELECT(.+?)FROM/is);
  if (!selectClauseMatch) return sqlQuery;

  const selectClause = selectClauseMatch[1];
  const restOfQuery = sqlQuery.slice(selectClauseMatch[0].length);
  const columns = selectClause.split(',').map(col => col.trim());

  const updatedColumns = columns.map(column => {
    let expression = column;
    let alias = '';

    const duplicateAliasRegex = /^(.*?"[^"]+")\s+"[^"]+"$/;
    let duplicateMatch = column.match(duplicateAliasRegex);
    if (duplicateMatch) {
      expression = duplicateMatch[1];
    }

    let regexMatch = expression.match(/^(.*?)\s+AS\s+(".*?"|[^\s]+)$/i);
    if (regexMatch) {
      expression = regexMatch[1].trim();
      alias = regexMatch[2].replace(/^"|"$/g, '');
    } else {
      regexMatch = expression.match(/(?:\w+\.)?"([^"]+)"$/);
      if (regexMatch) {
        alias = regexMatch[1];
        const duplicateColumnRegex = new RegExp(`^(.*?)\\s+"${alias}"$`);
        const duplicateColumnMatch = expression.match(duplicateColumnRegex);
        if (duplicateColumnMatch) {
          expression = duplicateColumnMatch[1];
        }
      }
    }

    if (alias && aliasMap.hasOwnProperty(alias)) {
      const newAlias = aliasMap[alias];
      if (newAlias && typeof newAlias === 'string') {
        return `${expression} AS ${formatSqlAlias(newAlias)}`;
      }
    }
    return column;
  });

  const newSelectClause = updatedColumns.join(',\n    ');

  return `SELECT\n    ${newSelectClause}\nFROM${restOfQuery}`;
}

export default replaceSqlAliases;
